<template>
    <div class="container">
        <h1>Lịch sử giao dịch</h1>
        <b-button v-b-toggle.collapse-1 variant="primary">Thêm mới</b-button>
        <b-collapse id="collapse-1" class="mt-2">
            <b-card>
                <div>
                    <div>Người mua: <a href="#" @click="viewClient(newTransactionForm.buyer_id)" v-if="newTransactionForm.buyer_id">Xem</a>
                        <vue-bootstrap-typeahead 
                                v-model="newTransactionForm.buyer_fullname"
                                :minMatchingChars="1"
                                :data="clientList"
                                :serializer="this.clientLabel"
                                @hit="newTransactionForm.buyer_id = $event['id']"
                                />

                        <b-button variant="danger" size="sm" @click="newTransactionForm.buyer_id='';newTransactionForm.buyer_fullname=''">x</b-button>
                    </div>
                    <div>Người bán: <a href="#" @click="viewClient(newTransactionForm.seller_id)" v-if="newTransactionForm.seller_id">Xem</a>
                        <vue-bootstrap-typeahead 
                                v-model="newTransactionForm.seller_fullname"
                                :minMatchingChars="1"
                                :data="clientList"
                                :serializer="this.clientLabel"
                                @hit="newTransactionForm.seller_id = $event['id']"
                                /> 

                        <b-button variant="danger" size="sm" @click="newTransactionForm.seller_id='';newTransactionForm.seller_fullname=''">x</b-button>
                            
                    </div>
                    <p>Ngày bán</p>
                    <b-form-input type="date" v-model="newTransactionForm.date_bought"/>
                    <p>Giá bán</p>
                    <b-form-input type="number" v-model="newTransactionForm.price_bought" placeholder="Giá bán" />
                    <p v-if="newTransactionForm.notes">Ghi chú thêm</p>
                    <b-textarea v-model="newTransactionForm.notes"/>

                    <b-button variant="primary" @click="submitTransaction">Lưu</b-button>
                </div>
            </b-card>
        </b-collapse>
        <hr/>

        <b-spinner v-if="isLoadingList"></b-spinner>
        <div v-if="!isLoadingList">
            <!-- <div v-for="t in transactions" v-bind:key="t.id" >
                <div class="row">
                    <div class="col-10 col-md-10">
                        <p>Người mua: <a href="#" @click="viewClient(t.buyer_id)">{{t.buyer_name}}</a></p>
                        <p>Người bán:  <a href="#" @click="viewClient(t.seller_id)">{{t.seller_name}}</a></p>
                        <p>Ngày bán: {{formatDate(t.date_bought)}}</p>
                        <p>Giá bán: {{t.price_bought}}</p>
                        <p>Ghi chú thêm: {{t.notes}}</p>
                    </div>
                    <div class="col-2 col-md-2">
                        <b-button variant="info" size="sm" @click="enableEdit(t.id)">Sửa</b-button>
                        
                    </div>
                </div>
                <hr/>
            </div> -->

            <b-table striped 
                sticky-header
                head-variant="light"
                :items="transactions"
                :fields="fields"
                sort-icon-left
                responsive="sm"
                >
                    <template #cell(buyer_id)="data">
                        <a href="#" @click="viewClient(data.item.buyer_id)">{{data.item.buyer_name}}</a>
                    </template>

                    <template #cell(seller_id)="data">
                        <a href="#" @click="viewClient(data.item.seller_id)">{{data.item.seller_name}}</a>
                    </template>

                    <template #cell(date_bought)="data">
                        {{formatDate(data.item.date_bought)}}
                    </template>

                    <template #cell(actions)="data">
                        <b-button variant="danger" size="sm" @click="remove(data.item.id)">Xoá</b-button> 
                    </template>
                    
                </b-table>
        </div>
    </div>
</template>

<script>
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'
import ProductTransactionMeta from '@/module-product-transactions/ProductTransactionsMeta'
import GenericTableView from '@/views/base/GenericTableView'
import TransactionService from '@/module-product-transactions/ProductTransactionService'
import ClientService from '@/module-client/ClientService'

import Firebase from '@/services/firebase'
import moment from 'moment';

export default {
  name: 'ProductTransactionList',
  components: {
      'vue-bootstrap-typeahead': VueBootstrapTypeahead,
  },
  computed () {

  },
  data () {
    return {
        transactions: [],
        fields: [
            { key: 'buyer_id', sortable: true , label: 'Người mua'},
            { key: 'seller_id', sortable: true, label: 'Người bán'},
            { key: 'price_bought', sortable: true, label: 'Giá giao dịch' },
            { key: 'date_bought', sortable: true, label: 'Ngày giao dịch' },
            { key: 'address' },
            { key: 'actions'}
        ],
        clientList: [{
            id: 1,
            fullname: 'text 1'
        }],
        newTransactionForm: {
            seller_fullname: '',
            seller_id: 0,
            buyer_fullname: '',
            buyer_id: 0,
            date_bought: new Date(),
            price_bought: 0,
            notes: ''
        },
        isLoadingList: false,
        transactionService: null
    }
  },
  
  methods: {
      clientLabel(s) {
          return s.fullname + '-' + s.phone
      },

      formatDateTime(v) {
          return moment(v).format('DD/MM/YYYY hh:mm:ss')
      },

      formatDate(v) {
          return moment(v).format('DD/MM/YYYY')
      },

      viewClient(id) {
          let routeData = this.$router.resolve({path: `/v2/clients/${id}/view`, query: {  }});
            window.open(routeData.href, '_blank');
      },

      async remove(id) {
          this.isLoadingList = true;
          await this.transactionService.remove(id);
          this.loadTransactionList();
          this.isLoadingList = false;
      },

      async loadTransactionList () {
          this.isLoadingList = true;
        var transactions = await this.transactionService.listAllByProduct(this.productId);
        this.transactions = transactions;

        this.isLoadingList = false;

        // console.log(this.transactions)
    },

    async loadClientList () {
        var service = new ClientService();
        var results = await service.listSimple2();
        this.clientList = results;

        console.log('Client ', results);
    },

    async submitTransaction() {
        const notes = encodeURI(this.newTransactionForm.notes);

        await this.transactionService.submitTransaction(
            this.productId, 
            this.newTransactionForm.seller_id,
            this.newTransactionForm.buyer_id,
            this.newTransactionForm.price_bought, 
            this.newTransactionForm.date_bought, 
            notes, 
            this.newTransactionForm.created_by
            );
        this.loadTransactionList();
    },

    rowClicked (event) {
        // console.log('row click');

        // let routeData = this.$router.resolve({path: `/v2/products/${event.id}/transactions`});
        // window.open(routeData.href, '_blank');
        // this.$router.push({ path: `/v2/products/${event.id}` }) 
    },
  },
  props: ['productId'],
  mounted () {
      Firebase.auth.onAuthStateChanged( user => {
        if (user) {
            this.newTransactionForm.created_by = user.email;
        }
      })

      this.transactionService = new TransactionService();
      this.loadClientList();
    this.loadTransactionList();
  }
}
</script>

<style scoped>
</style>
